import React, { Component } from "react";
import * as CONSTS from "../../assets/consts";
import * as Actions from "../actions/DoorbellActions";
import { connect } from "react-redux";

import { translate } from "../locales/translate";

import DropdownAlert from "react-native-dropdownalert";
import ArTheme from "../argon-ui/Theme";
import IPCameraHelper from "../modules/cameraHelper/IPCameraHelper";

class DropdownAlertHelper extends Component {
  constructor(props) {
    super(props);
    this.dropDownAlertRef = undefined;
    this.state = {
      waitingCameraId: undefined,
      waitingCameraUId: undefined,
    };
  }

  handleOnTap = async (d) => {
    if (this.state.waitingCameraId) {
      this.dropDownAlertRef.alertWithType(
        "success",
        "\r\n\r\n" + translate("app.loading"),
        "\r\n\r\n" + translate("app.wait"),
        {},
        3 * 1000
      );
      let serverUrl = this.props.appReducer.serverUrl;
      let access_token = this.props.appReducer?.currentServer.accessToken;
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      var query = [];
      if (this.state.waitingCameraId) {
        query.push(`id=${this.state.waitingCameraId}`);
      } else if (this.state.waitingCameraUId) {
        query.push(`uId=${this.state.waitingCameraUId}`);
      }
      var cameraGetInfoUrl = `${serverUrl}Camera/V380Info?${query.join("&")}`;
      // console.log(
      //   "cameraGetInfoUrl in DoorbellAlertHelper.handleOnTap()",
      //   cameraGetInfoUrl
      // );

      fetch(cameraGetInfoUrl, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      })
        .then((res) => {
          if (res.status == 200) {
            return res.json();
          } else return { status: res.status };
        })
        .then((resj) => {
          if (resj.result && resj.camera) {
            let { cameraId, friendlyName, ip, port, userName, password } =
              resj.camera;

            if (cameraId && ip && port && userName && password) {
              var camHelper = new IPCameraHelper();
              camHelper.play(
                friendlyName,
                ip,
                port,
                cameraId,
                userName,
                password,
                true,
                serverUrl,
                access_token
              );
            }
          }
        })
        .catch(console.log);
    }

    this.props.resetWaitingCameraId();
    // this.setState({ waitingCameraId: undefined }, () => {
    //   this.props.resetWaitingCameraId()
    // });
  };

  handleOnCancel = () => {
    this.dropDownAlertRef.closeAction();
    this.props.resetWaitingCameraId();
  };

  componentDidUpdate() {
    let { waitingCameraId, messageToast } = this.props.appReducer;
    var deviceName = "";

    if (waitingCameraId == this.state.waitingCameraId) {
      return;
    }
    for (var i in this.props.DeviceReducer.list) {
      var dvc = this.props.DeviceReducer.list[i];
      if (dvc.cameraId == waitingCameraId) {
        //console.log("camera info in DoorbellAlert", dvc);
        deviceName = dvc.deviceName;
        break;
      }
    }
    //if (waitingCameraId) {

    this.setState({ waitingCameraId }, () => {
      if (waitingCameraId) {
        const _waitingCameraId = waitingCameraId;
        // console.log(
        //   "waitingCameraId in DropdownAlertHelper.componentWillReceiveProps()",
        //   waitingCameraId
        // );
        this.handleOnTap();
        // this.dropDownAlertRef.alertWithType(
        //   "error",
        //   "\r\n\r\n" + translate("device.doorbellPressedNotificationTitle"),
        //   "\r\n\r\n" + deviceName,
        //   { _waitingCameraId },
        //   20 * 1000
        // );
      }
    });
    //}
  }
  render() {
    return (
      <DropdownAlert
        ref={(ref) => (this.dropDownAlertRef = ref)}
        onTap={this.handleOnTap}
        updateStatusBar={false}
        errorImageSrc={CONSTS.BRANDING.ICON}
        errorColor={ArTheme.COLORS.TL_PURPLE + "CC"} // "CC" adds ~80% transparency
        showCancel={true}
        onCancel={this.handleOnCancel}
        // renderCancel={() => (
        //   <Text
        //     style={{
        //       color: "#FFF",
        //       fontWeight: "bold",
        //       marginTop: 25,
        //       backgroundColor: "#555",
        //       padding: 6,
        //       borderRadius: 6,
        //     }}
        //   >
        //     {translate("app.cancel")}
        //   </Text>
        // )}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    DeviceReducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetWaitingCameraId: () => {
      dispatch(Actions.resetWaitingCameraId());
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropdownAlertHelper);
